<template>
  <div>
    <van-sticky>
      <van-nav-bar :border="false" >
        <template #title>
          <strong>添加/更换银行卡</strong>
        </template>
        <template #left>
          <span class="iconfont icon-houtui fs-24 fw-700" @click="$router.replace('/withdraw')"></span>
        </template>
      </van-nav-bar>
    </van-sticky>
    <van-form class="pt-20 pl-15 pr-15" @submit="bankmation">
      <div class="form-item">
        <label class="label">账户名</label>
        <input :value="userAccountInfo.real_name" type="text" placeholder="请输入账户名" disabled class="input">
      </div>
      <div class="form-item">
        <label class="label">开户行</label>
        <div class="select flex align-center justify-between" @click="show = true">
          <span>{{ bank_name ? bank_name : '请选择开户行' }}</span>
          <van-icon name="arrow-down" />
        </div>
      </div>
      <div class="form-item">
        <label class="label">分行信息</label>
        <input v-model="branch" type="text" placeholder="请输入分行信息" class="input">
      </div>
      <div class="form-item">
        <label class="label">卡号 / 账号</label>
        <input v-model="account_no" type="text" placeholder="请输入卡号 / 账号" maxlength="18" class="input">
      </div>
      <div style="margin: 16px;">
        <van-button color="#fc3159" round block type="info" native-type="submit" :disabled="!isActive">
          提交
        </van-button>
      </div>
    </van-form>
    <van-action-sheet v-model="show" :actions="bankList" cancel-text="取消" close-on-click-action @select="onSelect" />
  </div>
</template>

<script>
import { getBankList, getBankInfo, bankmation } from '@/api/common.js'
import { mapState } from 'vuex'
export default {
  name: 'BindCard',
  data() {
    return {
      show: false, // 开户行列表面板
      bank_name: '', // 开户行
      branch: '', // 分行信息
      account_no: '', // 卡号
      bankList: []
    }
  },
  computed: {
    isActive() {
      return this.account_no && this.bank_name && this.branch && this.bank_name
    },
    ...mapState(['userAccountInfo'])
  },
  async created() {
    try {
      this.$store.commit('TOGGLE_LOADING', true)
      await this.getBankInfo()
      await this.getBankList()
    } finally {
      this.$store.commit('TOGGLE_LOADING', false)
    }
  },
  methods: {
    async getBankInfo() {
      const res = await getBankInfo({})
      if (res.code === 1) {
        const { account_no, bank_name, name, branch } = res.data
        this.name = name
        this.branch = branch
        this.bank_name = bank_name
        this.account_no = account_no
      }
    },
    async getBankList() {
      const res = await getBankList({})
      this.bankList = res.data.map(val => ({ id: val.id, name: val.bank_name, color: val.bank_name == this.bank_name ? '#fc3159' : '' }))
    },
    async bankmation() {
      const params = {
        name: this.userAccountInfo.real_name,
        bank_name: this.bank_name,
        branch: this.branch,
        account_no: this.account_no
      }
      try {
        this.$store.commit('TOGGLE_LOADING', true)
        const res = await bankmation(params)
        this.$toast.success(res.msg)
      } finally {
        this.$store.commit('TOGGLE_LOADING', false)
        this.$router.back()
      }
    },
    onSelect(evt) {
      this.bank_name = evt.name
      this.bankList = this.bankList.map(val => ({ id: val.id, name: val.name, color: evt.name === val.name ? '#fc3159' : '' }))
    }
  }
}
</script>

<style lang="scss" scoped>
.form-item{
  display: flex;
  flex-direction: column;
  padding: 0 15px;
  margin-bottom: 26px;
  .label{
    font-size: 12px;
    color: #B7BDCA;
  }
  .input, .select{
    height: 50px;
    line-height: 50px;
    border-bottom: 1px solid #eee;
    padding: 10px 0;
    color: #0D0E15;
  }
}
</style>
